<template>
  <div class="banner">
    <div class="banner-desc">
      <p class="banner-desc__tx1 pos-y">休閒時光</p>
      <p class="banner-desc__tx2 pos-y">清爽、輕盈，呈現自然美</p>
      <button class="click-btn">{{ $t('btns.now_check') }}</button>
    </div>
    <img src="./images/1753@2x.png" alt />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  components: {},
};
</script>

<style scoped lang='less'>
.banner {
  height: 758px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .banner-desc {
    position: absolute;
    margin-top: 204px;
    margin-left: 165px;
    line-height: 1;

    .banner-desc__tx1 {
      height: 71px;
      font-size: 48px;
      color: #ffffff;
    }
    .banner-desc__tx2 {
      height: 59px;
      font-size: 40px;
      color: #ffffff;
    }
    .click-btn {
      cursor: pointer;
      margin-top: 25px;
      width: 125px;
      height: 40px;
      background: var(---unnamed-color-ec4f00);
      box-shadow: 0px 3px 6px #00000029;
      font-size: 16px;
      font-weight: lighter;
      color: var(--unnamed-color-ffffff);
    }
  }
}
</style>
